import { ColorValueStrict } from 'fronton-react';
import { css } from 'linaria';
import { styled } from 'linaria/react';
import { Section } from '../section';

export type BannerStyledSectionProps = {
  bgColor: ColorValueStrict | string;
};

export const BannerStyledSection = styled(Section)<BannerStyledSectionProps>`
  width: 100%;
  background: ${({ bgColor }: BannerStyledSectionProps) => bgColor};
  border-radius: var(--rounding-l);
`;

export const bannerLink = css`
  && {
    display: flex;
    width: 100%;
    height: 96px;

    @media (--to-desktop) {
      height: 100%;
    }
  }
`;

export const bannerLogoWrapper = css`
  @media (--only-mobile) {
    order: 2;
    margin-left: auto;
  }
`;

export const bannerLogo = css`
  display: block;
  width: 144px;
  height: 100%;
  border-radius: var(--rounding-l) 0 0 var(--rounding-l);
  object-fit: cover;

  @media (--only-mobile) {
    width: 75px;
    border-radius: 0 var(--rounding-l) var(--rounding-l) 0;
  }
`;

export const bannerTextBlock = css`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  width: 100%;
  padding: 0 24px;

  @media (--only-tablet) {
    flex-direction: column;
    align-items: flex-start;
    padding: 22px 24px;
  }

  @media (--only-mobile) {
    flex-direction: column;
    align-items: flex-start;
    flex-grow: unset;
    width: 213px;
    padding: 24px 16px;
    padding-right: 32px;
  }
`;

export const bannerNameWrapper = css`
  display: flex;
  align-items: center;
  margin-right: 8px;
  column-gap: 8px;

  @media (--to-desktop) {
    margin-right: 0;
    margin-bottom: 16px;
  }
`;

export const bannerName = css`
  && {
    @media (--from-desktop) {
      white-space: nowrap;
    }

    @media (--only-desktop) {
      font-size: 20px;
      line-height: 26px;
    }

    @media (--to-desktop) {
      font-size: 18px;
      line-height: 24px;
    }
  }
`;

export const bannerNameChevronIcon = css`
  && {
    @media (--only-tablet) {
      width: 20px;
      height: 20px;
    }

    @media (--only-mobile) {
      display: none;
    }
  }
`;

export const bannerList = css`
  && {
    display: flex;

    li {
      column-gap: 8px;

      @media (--only-mobile) {
        margin-right: 0;
        margin-bottom: 16px;
      }
    }

    @media (--only-mobile) {
      flex-direction: column;
    }

    li:not(:last-child) {
      margin-right: 24px;
      margin-bottom: 0;
    }
  }
`;
